import * as Yup from 'yup'
import { emailValidation, passwordValidation } from './common'

export const signInSchema = Yup.object({
  email: emailValidation,
  password: passwordValidation,
})
